import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { useLocationPicker } from '../store';

type LocationGroupProps = {
  children: React.ReactNode;
};

export const LocationGroup = ({ children }: LocationGroupProps) => {
  const { groupViewId, setGroupViewId } = useLocationPicker(['groupViewId', 'setGroupViewId']);

  return (
    <>
      <Text
        css={css`
          margin-top: ${theme.spacing(1)};
          margin-left: ${theme.spacing(2)};
        `}
        size='large'
        weight='bold'
      >
        Location Groups
      </Text>
      <Accordion
        css={css`
          padding: ${theme.spacing(2, 2)};
        `}
        isMulti={false}
        variant='main'
        chevronIcon={() => <Icon name='caret-down-small' />}
        isInteractive
        controlledValue={groupViewId}
        onChange={setGroupViewId}
      >
        {children}
      </Accordion>
    </>
  );
};
